import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "War on scientology",
  "description": "",
  "published": "2008-02-11T00:00:00.000Z",
  "redirect_from": ["/blog/war-on-scientology/swizec/128"],
  "categories": "food for thought, intrigues",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There is a war going on, a great war, a war of many casualties and civilian artefacts, a war of many a brainwashed noob and hardened pro and undoubtedly, one day, a war of many veterans and hearsay. It's a cyberwar ... mostly ... and it's happening right at our cyber doorstep. Well ok, everything is our cyber doorstep because that's how the cyberworld works, but some other time about that.`}</p>
    <p>{`How the war actually began I cannot say. Why it began? I haven't a clue. But I can tell you where I hear about it. From my geeky msn people who visit the nether regions of the internets and fetch me news updates of this holiest of crusades against everything ungeeky.`}</p>
    <p>{`For some reason the whole american side of the geek community is bent upon destroying the evil that is scientology by any means possible. I'm not exactly certain what causes this heated response, but I am told scientology is an evil entity, worse even than Microsoft (in that both sides of the opensource coin are against it), bent upon destroying all that stand in its path. It is supposedly illegal and will continue to convince stupid people to shove large lumps of money down its throat.`}</p>
    <p>{`One day, seemingly out of the blue, a crusade against scientology began with a simple request to DoSS its website. Then it went onwards with people hacking the website and with people knocking politely on its front door and asking it to please have a cup of shut the fuck up. But apparently it wouldn't listen and now things are, if you ask me, getting out of hand. Protestations in the streets against scientology? Soon to be riots against scientology?`}</p>
    <p>{`Why the fuck people? It's just a bloody cult that means nothing, absolutely nothing. They're a cult just like Christendom was a cult. Stop feeding them. Stop giving them publicity. Do you not see you are doing exactly what scientology wants you to do? You're making this irrelevant little cult into something big and important. You stupid fucks are giving it power and because of you and your arrogant ignorance it will soon be the death of us all. Just you wait, the inquisition is nigh.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      